




















































import { Component, Vue } from 'vue-property-decorator';
import { openHostedUi } from '@/auth/auth';

@Component
export default class LoginView extends Vue {
  launchLogin() {
    openHostedUi();
  }
}
